import { Injectable, inject } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';

import { mergeMap, tap } from 'rxjs/operators';

import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { safeMap } from '@era/stores';
import { environment } from '@rocksoft/environment';
import { IntegrationMDMPairingService, PairChallenge } from '@rocksoft/settings-sdk';
import { PairConfirmContainerActions, PairingApiActions } from './pairing.actions';

@Injectable()
export class PairingEffects {
  private pairingService = inject(IntegrationMDMPairingService);
  private readonly actions$ = inject(Actions);
  private readonly httpClient = inject(HttpClient);

  verifyCodeRequestedEffect$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(PairConfirmContainerActions.verifyCodeRequested),
      mergeMap(({ code }) => {
        if (environment.local && this.pairingService.configuration.basePath) {
          const url = new URL(this.pairingService.configuration.basePath);
          url.hostname = window.location.hostname;
          this.pairingService = new IntegrationMDMPairingService(this.httpClient, url.origin);
        }

        return safeMap(
          this.pairingService.verifyPairCode({ code }),
          (pairChallenge: PairChallenge) => PairingApiActions.verifyCodeValid({ pairChallenge }),
          (httpErrorResponse: HttpErrorResponse) => {
            if (httpErrorResponse.error?.error?.innerError?.code === 'InvalidToken') {
              return PairingApiActions.verifyCodeInvalid();
            } else {
              return PairingApiActions.verifyCodeError({ error: httpErrorResponse });
            }
          }
        );
      })
    );
  });

  enrollmentRequestedEffect$ = createEffect(
    () => {
      return this.actions$.pipe(
        ofType(PairConfirmContainerActions.enrollmentRequested),
        tap(({ challenge }) => {
          if (environment.local) {
            const url = new URL(`${environment.mdm.enrollUrl}/${challenge}`);
            url.hostname = window.location.hostname;
            window.location.href = url.toString();
          } else {
            window.location.href = `${environment.mdm.enrollUrl}/${challenge}`;
          }
        })
      );
    },
    { dispatch: false }
  );
}
